import React, { useEffect, useState } from "react";
import { Box, Typography, Tabs, Tab, Grid, Checkbox, Button, Stepper, Step, StepLabel, TextField } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { getListAPI } from '../../../components/pmorder/PmorderAPI';
import ProductInfo from "./ProductInfo";
import { setCompleteTaskButtonEnabled, setReferbackTaskButtonEnabled, setHideTaskActionBar } from "store/slice/AppSlice";
import { setTaskApiResponse, setTaskApiResponseError } from 'store/slice/AppSlice';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import PmorderDashboard from "components/pmorder/PmorderDashboard";
import { getListAPI as getPMunitList } from 'components/dmunit/DmunitAPI';
import { setDmunitList } from "store/slice/PharmaSlice";
import { getPmorderInfoByProductidAPI } from 'components/pmorder/PmorderAPI';
import { setPmorderList, setPmorderDashboardPmorderList } from "store/slice/PharmaSlice";
import { placePMorderAPI } from "api/OmsOrdermgmtWebServices";
import MuiAlert from '@mui/material/Alert';
import { initRefreshTaskList } from "store/slice/AppSlice";
import { updateProductInfo } from "components/product/ProductAPI";
import {updateProductObj} from "store/slice/PharmaSlice";
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import FieldView2 from "core/components/layout/FieldView2";
import CommentMgmt from "./comment/CommentMgmt";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';



export default function TaskSpaceStoreStockCheck() {
  const dispatch = useDispatch();

  const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
  const { selectedTaskObj } = useSelector((state) => state.appslice.wkflow);
  const { taskApiResponse, taskApiResponseError } = useSelector((state) => state.appslice.wkflow);
  const [designMaterialAvailable, setDesignMaterialAvailable] = useState(productObj.designstatus);
  const [orderDate, setOrderDate] = useState("");
  const { pmorderList } = useSelector((state) => state.pharmaslice.pmorderDashboard);
  const [isOrderPlaced, setIsOrderPlaced] = useState(false);
  const [editSetNameOpen, setEditSetNameOpen] = useState(false);
  const [setNameInput, setSetNameInput] = useState(productObj.setname || "");
  const [setNameSaving, setSetNameSaving] = useState(false);
  const [canComplete, setCanComplete] = useState(false);
  const {showEdit} = useSelector((state) => state.pharmaslice.pmorderDashboard);
  const [tabIndex, setTabIndex] = useState(0);
  const {pharmasetList} = useSelector(state => state.pharmaslice);

  useEffect(() => {
    if (showEdit){
      dispatch(setCompleteTaskButtonEnabled(false));
      dispatch(setTaskApiResponseError(''));
    }
    else
       dispatch(setCompleteTaskButtonEnabled(true));
  },[showEdit]);


  useEffect(() => {
   // dispatch(setHideTaskActionBar(true));
    //if (pmorderList.length > 0) setDesignMaterialAvailable('no');
  }, [pmorderList])
  useEffect(() => {
    // Convert ISO date to yyyy-MM-dd format for the input
    if (productObj.designorderedon) {
      const date = new Date(productObj.designorderedon);
      if (!isNaN(date)) {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        setOrderDate(`${yyyy}-${mm}-${dd}`);
      } else {
        setOrderDate("");
      }
    } else {
      setOrderDate("");
    }
  }, [productObj]);

  useEffect(() => {
    setCanComplete( canCompleteTask() );
  },[productObj,pmorderList,designMaterialAvailable, isOrderPlaced]);

  useEffect(() => {
    dispatch(setTaskApiResponse(null));
    dispatch(setTaskApiResponseError(''));
    dispatch(setCompleteTaskButtonEnabled(true));
    dispatch(setHideTaskActionBar(false));
    dispatch(setPmorderList([]));
    dispatch(setPmorderDashboardPmorderList([]));

    getPMunitList(() => { }, (list) => { dispatch(setDmunitList(list)) });

    getPmorderInfoByProductidAPI(productObj.id, () => { }, (response) => {
      dispatch(setPmorderList(response));
      dispatch(setPmorderDashboardPmorderList(response));
    });
  }, []);
  useEffect(() => {
      updateProductInfo(
        productObj.id,{ 
          designstatus: designMaterialAvailable
        },
        (response) => {
          dispatch(updateProductObj(response));
        },
        (error) => {
          console.error("Error updating design material", error);
          dispatch(setTaskApiResponseError(error));
        }
      );
  },[designMaterialAvailable]);

 const updateOrderDate = (date) => {
  updateProductInfo(
        productObj.id,{ 
          designorderedon: date
        },
        (response) => {
          dispatch(updateProductObj(response));
        },
        (error) => {
          console.error("Error updating design material", error);
          dispatch(setTaskApiResponseError(error));
        }
      );
 }

// const completeTask = () => {
//   placePMorderAPI({
//     productId: productObj.id,
//     orderDate: orderDate,
//     taskInstanceId: selectedTaskObj.id,
//   }, (response) => {
//     dispatch(initRefreshTaskList());
//     dispatch(setPmorderDashboardPmorderList(response.pmorderInfoList.list));
//     setIsOrderPlaced(true);
//   }, (error) => {
//     dispatch(setTaskApiResponseError(error));
//   });
// }

const handleEditSetNameOpen = () => {
  setSetNameInput(productObj.setname || "");
  setEditSetNameOpen(true);
};

const handleEditSetNameClose = () => {
  setEditSetNameOpen(false);
};

const handleSetNameSave = () => {
  console.log("setNameInput=>" + setNameInput);
  setSetNameSaving(true);
  updateProductInfo(
    productObj.id,
    { setname: setNameInput },
    (response) => {
      dispatch(updateProductObj(response));
      setEditSetNameOpen(false);
      setSetNameSaving(false);
    },
    (error) => {
      setSetNameSaving(false);
      // Optionally show error
    }
  );
};
const canCompleteTask = () => {
  // if (isOrderPlaced) return false;
  // if (productObj.setname=== "") return false;

  // if (pmorderList.length === 0) return false 
    

  // if (designMaterialAvailable === 'ORDERED' && productObj.designorderedon!=='') return true;

  // if (pmorderList.length > 0 ) {
  //   return true;
  // }
  // return false;
  return true;
};

  return (
    <Grid container direction="row" sx={{ width: '100%' }}>
      <Grid item lg={12} md={12} sm={12} xs={12} sx={{ mb: 2 }}>
        <Grid container sx={{ width: '100%' }}>
          <Grid item lg={4} md={4} sm={12} xs={12}>
                  <Box sx={{ borderRadius: 2, minHeight: '72vh', p: 0 }}>
                    <Tabs
                      value={tabIndex}
                      onChange={(_, v) => setTabIndex(v)}
                      variant="fullWidth"
                      sx={{ borderBottom: 1, borderColor: 'divider' }}
                    >
                      <Tab label="Product Info" />
                      <Tab label="Comments" />
                    </Tabs>
                    <Box sx={{}}>
                      {tabIndex === 0 && (
                        <ProductInfo maxHeight="70vh" />
                      )}
                      {tabIndex === 1 && (
                        <Box sx={{ p: 2, minHeight: '70vh' }}>
                          <Box sx={{ backgroundColor: 'white', borderRadius: 2, p: 1 }}>
                            <CommentMgmt maxHeight="60vh" status={1} />
                          </Box>
                        </Box>
                      )}
                    </Box>
                  </Box>
                </Grid>
          <Grid item lg={8} md={4} sm={4} xs={12}>
            <Grid container direction="column" sx={{ width: '100%' }}>
              
              <Grid item lg={12} md={12} sm={12} xs={12} sx={{ mt: 2 }}>
                <Box sx={{ borderRadius: 2,  }}>
                  <Grid container>
                    {/* {designMaterialAvailable === 'ORDERED' && ( */}
            
                    <Grid item lg={12} md={12} sm={12} xs={12} sx={{backgroundColor:'white', borderRadius: 2, p: 2 }}>
                      {!isOrderPlaced ? (
                        <PmorderDashboard />
                      ) : (
                        <>
                        <Grid container direction="row" sx={{ mb: 2 }}>
                          {pmorderList && pmorderList.length > 0 ? (
                            pmorderList.map((order, idx) => (
                              <Grid item lg={3} md={2} sm={2} xs={4} key={order.id || idx} sx={{ p: 1 }}>
                                <Box
                                  key={order.id || idx}
                                  sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 0.5,
                                    mb: 1,
                                    alignItems: "flex-start",
                                    backgroundColor: "secondary.100",
                                    borderRadius: 1,
                                    p: 1.5,
                                  }}
                                >
                                  <Typography variant="h5" sx={{ fontWeight: 500 }}>
                                    {order.title}
                                  </Typography>
                                  <Typography variant="body2" color="text.secondary">
                                    {order.qty} {order.unitname}
                                  </Typography>
                                </Box>
                                </Grid>
                            ))
                          ) : (
                            <Typography variant="body2" color="text.secondary">
                              No orders found.
                            </Typography>
                          )}
                          </Grid>
                        </>
                      )}
                    </Grid> 
                    {/* )} */}
                    {/* <Grid item lg={12} md={12} sm={12} xs={12} sx={{ mt: 4, display: "flex", justifyContent: "flex-end" }}>
                      {isOrderPlaced ? (
                        <MuiAlert severity="success" sx={{ width: 'auto', justifyContent: "flex-end", display: "flex" }}>
                          Order placement is recorded successfully !!!
                        </MuiAlert>
                      ) : (
                        <Button
                          variant="contained"
                          color="primary"
                          sx={{ minWidth: 160 }}
                          disabled={!canComplete}
                          onClick={() => { completeTask() }}
                        >
                          Complete Task
                        </Button>
                      )}
                    </Grid> */}
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Set Name Edit Dialog */}
      <Dialog open={editSetNameOpen} onClose={handleEditSetNameClose} maxWidth="xs" fullWidth>
        <DialogTitle>Edit Set Name</DialogTitle>
        <DialogContent>
          <Select
            label="Set Name"
            value={setNameInput}
            onChange={e => setSetNameInput(e.target.value)}
            fullWidth
            sx={{ mt: 1 }}
            displayEmpty
          >
            <MenuItem value="" disabled>
              Select Set Name
            </MenuItem>
            {pharmasetList && pharmasetList.map((set) => (
              <MenuItem key={set.id || set.title} value={set.title}>
                {set.title}
              </MenuItem>
            ))}
          </Select>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleEditSetNameClose} color="secondary" disabled={setNameSaving}>
            Cancel
          </Button>
          <Button
            onClick={handleSetNameSave}
            color="primary"
            variant="contained"
            //disabled={!setNameInput.trim() || setNameSaving}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}